import gql from 'graphql-tag';

import { PRICE_PLAN_FRAGMENT } from './PricePlan';

export const PURCHASED_PRODUCT_FRAGMENT = gql`
  fragment PurchasedProduct on PurchasedProduct {
    type
    tierId
  }
`;

export const PRODUCT_FRAGMENT = gql`
  fragment Product on Product {
    name
    type
    scope
    kind
    isSubscribed
    isTrialAvailable
    trialEnd
    trialDays
    hadTrial
    isTrialCancelled
    pricePlan {
      ...pricePlan
    }
  }
  ${PRICE_PLAN_FRAGMENT}
`;

export const PRODUCT_FOR_ADMIN_FRAGMENT = gql`
  fragment ProductForAdmin on Product {
    ...Product
    price
    quantity
    scheduledQuantity
    activeUntil
  }
  ${PRODUCT_FRAGMENT}
`;

export const ADD_ONS = gql`
  query addOns {
    addOns {
      ...Product
    }
  }
  ${PRODUCT_FRAGMENT}
`;

export const UPDATE_ADD_ONS = gql`
  mutation updateAddOn($input: UpdateAddOnInput!) {
    updateAddOn(input: $input) {
      paymentIntentSecret
      team {
        id
        purchasedProducts {
          ...PurchasedProduct
        }
      }
    }
  }
  ${PURCHASED_PRODUCT_FRAGMENT}
`;

export const PREPARE_SWITCHING_PLANS = gql`
  query prepareSwitchingPlans {
    prepareSwitchingPlans {
      additional
      currentPeriodEnd
      nextPrice
    }
  }
`;

export const SWITCH_PLANS = gql`
  mutation switchPlans($paymentIntentId: String) {
    switchPlans(paymentIntentId: $paymentIntentId) {
      paymentIntentSecret
      team {
        id
      }
    }
  }
`;

export const AVAILABLE_ADD_ONS = gql`
  query availableAddOns {
    availableAddOns {
      ...Product
    }
  }
  ${PRODUCT_FRAGMENT}
`;
